import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/adminApi';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';

export const ChatConversationDialog = ({ sessionId, onClose, onDelete }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!sessionId) return;
    setMessages([]);
    adminApi.get(`/chat/conversations/${sessionId}`).then(({ data }) => setMessages(data.data)).catch(() => {});
  }, [sessionId]);

  return (
    <Dialog open={!!sessionId} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="bg-slate-900 border-white/10 text-white sm:max-w-lg max-h-[85vh] flex flex-col" data-testid="chat-conversation-dialog">
        <DialogHeader>
          <DialogTitle>Conversación</DialogTitle>
          <DialogDescription className="text-slate-400 break-all">{sessionId}</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-2 pr-1" data-testid="chat-conversation-messages">
          {messages.length === 0 && <p className="text-sm text-slate-400">Cargando...</p>}
          {messages.map((m) => (
            <div key={m.id} className={`flex ${m.role === 'user' ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm whitespace-pre-wrap ${m.role === 'user' ? 'bg-blue-600' : 'bg-white/10 text-slate-100'}`}>
                {m.content}
                <p className="text-[10px] opacity-60 mt-1">{new Date(m.timestamp).toLocaleString('es-VE')}</p>
              </div>
            </div>
          ))}
        </div>
        <Button variant="outline" data-testid="chat-conversation-delete" onClick={() => window.confirm('¿Eliminar esta conversación?') && onDelete(sessionId)} className="rounded-xl border-red-500/40 bg-transparent text-red-300 hover:bg-red-500/10 hover:text-red-200 self-start">
          <Trash2 className="h-4 w-4 mr-2" /> Eliminar conversación
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ChatConversationDialog;
